export default "__VITE_ASSET__CuHhVMbQ__"